import { ReactComponent as ErrorSvg } from 'images/icons/error.svg'
import { ReactComponent as OfflineSvg } from 'images/icons/no-wifi.svg'
import { ReactComponent as OkSvg } from 'images/icons/ok.svg'
import { ReactComponent as WarningSvg } from 'images/icons/warning.svg'
import { ReactComponent as OnlineSvg } from 'images/icons/wifi.svg'
import BatteryGauge from 'react-battery-gauge'
import { ROBOT_NETWORK_STATUSES } from 'utils/constants'
import { getDiagnosticTooltipText } from 'utils/diagnosticsUtils'
import { IRobotInfo } from 'utils/interfaces'
import { VENDOR } from 'utils/vendorDisplayName'

import style from './RobotStatusIcons.module.css'

interface Props {
  robot: IRobotInfo
}

const RobotStatusIcons = ({ robot }: Props) => {
  const isOnline = robot.networkStatus === ROBOT_NETWORK_STATUSES.ONLINE
  const batteryPower = robot.batteryPower
  const systemDiagnostics = robot.systemDiagnostics

  const isAsbisWelder = robot.vendor === VENDOR.ASBIS && (robot.robot_type || '').toLowerCase().trim() === 'welder'

  const renderBatteryIcon = () => {
    if (isAsbisWelder) return null
    if (batteryPower === null || batteryPower === undefined) return null

    const roundedValue = Math.round(batteryPower)
    const isCharging = !!robot.isCharging
    const getBatteryColor = (value: number) => {
      if (value < 30) return '#f56565' // Red
      if (value < 70) return '#ed8936' // Orange
      return '#48bb78' // Green
    }

    return (
      <div className={style.batteryContainer} title={`Battery: ${roundedValue}%${isCharging ? ' (Charging)' : ''}`}>
        <BatteryGauge
          value={roundedValue}
          size={35}
          padding={2}
          animated={true}
          charging={isCharging}
          // orientation="vertical"
          customization={{
            batteryMeter: {
              fill: getBatteryColor(roundedValue),
              lowBatteryValue: 30,
            },
            readingText: {
              showPercentage: false,
              fontSize: 0,
            },
            chargingFlash: {
              scale: 0.0002,
              fill: 'orange',
              animated: false,
            },
          }}
        />
        <span>{roundedValue}%</span>
      </div>
    )
  }

  const renderDiagnosticIcon = () => {
    if (!systemDiagnostics) return null

    const { level } = systemDiagnostics
    const tooltip = getDiagnosticTooltipText(systemDiagnostics)
    let Icon = OkSvg
    let iconClass = style.diagOk

    if (level === 1) {
      Icon = WarningSvg
      iconClass = style.diagWarn
    } else if (level === 2 || level === 3) {
      Icon = ErrorSvg
      iconClass = style.diagError
    }

    return (
      <div className={`${style.statusItem} ${iconClass}`} title={tooltip ? `Diagnostics: ${tooltip}` : 'Diagnostics'}>
        <Icon className={style.statusIcon} />
      </div>
    )
  }

  return (
    <div className={style.statusContainer}>
      {/* <div className={style.statusItem} title={isOnline ? 'Online' : 'Offline'}>
        {isOnline ? <OnlineSvg className={style.statusIcon} /> : <OfflineSvg className={style.statusIcon} />}
      </div> */}
      {/* {isOnline && renderDiagnosticIcon()} */}
      {isOnline && renderBatteryIcon()}
    </div>
  )
}

export default RobotStatusIcons
